import { Organisation as OrganisationBase } from "cloud-core/organisation/Organisation";

export class Organisation extends OrganisationBase<number> {
    static createOrganisationAdminGroupId(): string {
        return "Gmt2vHwrYRpr";
    }

    static createOrganisationManagerGroupId(organisationId: string): string {
        return `G${organisationId}M`;
    }

    static createOrganisationBasicUserGroupId(organisationId: string): string {
        return `G${organisationId}B`;
    }
}
